// import { API_URL } from "../config";

// export const getHeaders = () => {
//   const token = localStorage.getItem("authToken");
//   return {
//     "Content-Type": "application/json",
//     Authorization: `Bearer ${token}`,
//   };
// };

// // export const apiCall = async (endpoint, method = "GET", data = null) => {
// //   const options = {
// //     method,
// //     headers: getHeaders(),
// //   };

// //   if (data) {
// //     options.body = JSON.stringify(data);
// //   }

// //   const response = await fetch(`${API_URL}${endpoint}`, options);
// //   if (!response.ok) throw new Error(`API error: ${response.statusText}`);
// //   return response.json();
// // };


// export const apiCall = async (endpoint, method = "GET", data = null) => {
//   const options = {
//     method,
//     headers: getHeaders(),
//   };

//   if (data) {
//     options.body = JSON.stringify(data);
//   }

//   const response = await fetch(`${API_URL}${endpoint}`, options);

//   if (!response.ok) throw new Error(`API error: ${response.statusText}`);

//   // ✅ Only parse JSON if there is content
//   const contentType = response.headers.get("content-type");
//   if (contentType && contentType.includes("application/json")) {
//     return response.json();
//   } else {
//     return {}; // or `null`, depending on your usage
//   }
// };


// import { API_URL } from "../config";

// export const getHeaders = () => {
//   const token = localStorage.getItem("authToken");
//   return {
//     "Content-Type": "application/json",
//     Authorization: `Bearer ${token}`,
//   };
// };

// export const apiCall = async (endpoint, method = "GET", data = null, contentType = null, isFormData = false) => {
//   const options = {
//     method,
//     headers: {},
//   };

//   if (!isFormData) {
//     options.headers = getHeaders();
//   } else {
//     const token = localStorage.getItem("authToken");
//     if (token) {
//       options.headers['Authorization'] = `Bearer ${token}`;
//     }
//   }

//   if (data) {
//     if (isFormData) {
//       options.body = data;
//       delete options.headers['Content-Type'];
//     } else {
//       options.body = JSON.stringify(data);
//     }
//   }

//   const response = await fetch(`${API_URL}${endpoint}`, options);

//   if (response.status === 302 || response.status === 301) {
//     const redirectUrl = response.headers.get('Location');
//     throw new Error(`Authentication required. Redirected to: ${redirectUrl}`);
//   }

//   if (!response.ok) {
//     throw new Error(`API error: ${response.status} ${response.statusText}`);
//   }

//   const responseContentType = response.headers.get("content-type");
//   if (responseContentType && responseContentType.includes("application/json")) {
//     const result = await response.json();
//     return result;
//   } else {
//     return { success: true, message: "Operation completed successfully" };
//   }
// };
import axios from "axios";
import { API_URL } from "../config";

const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 15000,
  withCredentials: true, // important if cookies used
});

/* =============================
   REQUEST INTERCEPTOR
============================= */
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* =============================
   RESPONSE INTERCEPTOR
============================= */
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Network / CORS error
    if (!error.response) {
      return Promise.reject(
        new Error("Network error. Please check your connection.")
      );
    }

    const status = error.response.status;
    const message =
      error.response?.data?.message ||
      "Something went wrong. Please try again.";

    /* ❌ DO NOT logout on 302 */
    if (status === 302) {
      return Promise.reject(new Error(message));
    }

    /* ✅ ONLY 401 means token invalid */
    if (status === 401) {
      // ❗ DO NOT clear token here
      const err = new Error("SESSION_EXPIRED");
      err.code = 401;
      return Promise.reject(err);
    }

    /* 🔐 Permission error */
    if (status === 403) {
      return Promise.reject(
        new Error("You do not have permission to perform this action.")
      );
    }

    return Promise.reject(new Error(message));
  }
);

/* =============================
   apiCall (same name preserved)
============================= */
export const apiCall = async (
  endpoint,
  method = "GET",
  data = null,
  contentType = null,
  isFormData = false
) => {
  const config = {
    url: endpoint,
    method: method.toLowerCase(),
  };

  if (data) {
    config.data = data;
  }

  if (isFormData) {
    config.headers = { "Content-Type": "multipart/form-data" };
  } else {
    config.headers = { "Content-Type": "application/json" };
  }

  const response = await axiosInstance(config);
  return response.data;
};
